/**
 * Entry point: wires the manifest + GameScene to the SDK.
 *
 * Uses the front camera ('user') because the player needs to see their
 * own pose mirrored back while flapping. The per-game theme reskins the
 * shell scenes (menu, lobby, about, gameover) with the Tappy Plane sky
 * background and button art so the launcher tiles stay visually distinct.
 */
import { bootGame } from '@platform/sdk';
import GameScene from './GameScene.js';
import manifest from '../manifest.json';

bootGame({
  manifest,
  GameScene,
  parent: 'game',
  // Front camera so the player can watch themselves flapping.
  cameraFacing: 'user',
  // Per-game visual theme for the SDK shell scenes.
  theme: {
    backgrounds: {
      MainMenu: 'sky',
      Lobby:    'sky',
      About:    'sky',
      GameOver: 'sky'
    },
    buttons: {
      primary:   { textureKey: 'btn_primary' },
      secondary: { textureKey: 'btn_secondary' }
    }
  }
});
